export const theme = {
  primary: "#35C974",
  secondary: "#3DDF6F",
  lingoColor: "#5340e7",
  danger: "hsla(357, 70%, 47%, 0.7)",
  greenLight: "#00E676",
  success: "#00C221",
  warning: "#ffc107",
  white: "#FFFFFF",
  lightGray: "#CCC",
  disable: "#EEEEEE",
  disableText: "#BBBBBB",
  calendarGreen: "hsl(91, 57%, 50%)",
  wrapper: "#F1F3F7",
  modal: "#000",
  text: "#333333",
  textBold: "#777",
  textLight: "#777777",
  shadow: "1px 1px 10px -5px #cdcdcd",
  shadowDark: "0px 0px 20px 0px #cdcdcd7a",
  confirmBoxShadow: "rgba(0, 0, 0, 0.15) 0px 10px 37px",
  fontWeight: "400",
  fontSize: "0.9em",
  headerHeight: "70px",
  // fontSizeLg: '1.1em',
  // fontSizeSm: '0.6em',
  darkGlass: "rgba(50, 50, 50, 0.85)",
  lightGlass: "rgba(50, 50, 50, 0.45)",
  fontSizeMd: "1em",
  fontSizeLg: "1.2em",
  fontSizeXl: "1.4em",
  fontSizeSm: "0.8em",
  fontSizeXs: "0.6em",
  borderRadius: "10px",
  radiusMd: "7px",
  buttonRadius: "5px 5px 5px 5px",
  border: "1px solid #CCC",
};
